import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Menu, Icon} from 'antd';

import * as d3 from "d3";
import _ from 'lodash';

import * as actions from '../../redux/actions';
import './index.css';
import PlayControls from "../PlayControls";
import {version} from '../../../package.json'

class SideMenu extends Component {
  render() {
    const onClick = function ({keyPath}) {
      let [field, key, key2] = keyPath;

      if (key2) {
        key = key2;
      }

      if (this.props.onClick) {
        this.props.onClick(field, key);
      }

      switch (key) {
        case 'x':
        case 'y':
          return this.props.actions.selectField(field.substring(2), key2);
        case 'state':
          const stateFips = +field;
          this.props.actions.selectState(stateFips);
          return this.props.actions.selectPage('state');
        case 'county':
          const countyFips = +field;
          this.props.actions.selectCounty(countyFips);
          return this.props.actions.selectPage('county');
        case 'year':
          const year = +field;
          return this.props.actions.selectYear(year);
        case 'page':
          return this.props.actions.selectPage(field);
        default :
          return;
      }
    };

    const selectedKeys = [
      this.props.page,
      'X-' + this.props.xField,
      'Y-' + this.props.yField,
      '' + this.props.selectedState.fips,
      '' + this.props.selectedCounty.fips,
      '' + this.props.year,
    ];

    const shouldDisable = function (key) {
      return _.includes(selectedKeys, key);
    };

    const fieldsX = _.chain(this.props.fields)
      .groupBy('category')
      .map((value, key) => {
        return {category: key, items: value}
      })
      .reduce((reducer, row) => {
        const children = _.map(row.items, f => {
          return (
            <Menu.Item key={'X-' + f.field} disabled={shouldDisable('Y-' + f.field)}>
              <a>
                {f.label}
                <div className="desc">{f.desc}</div>
              </a>
            </Menu.Item>
          )
        });

        reducer.push(
          <Menu.SubMenu
            className="scroller condensed"
            key={row.category}
            title={row.category}>
            {children}
          </Menu.SubMenu>
        );

        return reducer
      }, [])
      .value();

    const fieldsY = _.chain(this.props.fields)
      .groupBy('category')
      .map((value, key) => {
        return {category: key, items: value}
      })
      .reduce((reducer, row) => {
        const children = _.map(row.items, f => {
          return (
            <Menu.Item key={'Y-' + f.field} disabled={shouldDisable('X-' + f.field)}>
              <a>
                {f.label}
                <div className="desc">{f.desc}</div>
              </a>
            </Menu.Item>
          )
        });

        reducer.push(
          <Menu.SubMenu
            className="scroller condensed"
            key={row.category}
            title={row.category}>
            {children}
          </Menu.SubMenu>
        );

        return reducer
      }, [])
      .value();

    const mode = this.props.mobile ? "inline" : "vertical";

    return (
      <Menu selectedKeys={selectedKeys} onClick={onClick.bind(this)} className="SideMenu" theme="dark" mode={mode}>

        {this.props.mobile &&
        <Menu.SubMenu key="page" title={
          <span>
            <Icon type="desktop"/>
            <span className="title">Data View</span>
            <br/><span style={{textTransform: 'capitalize'}}>{this.props.page}</span>
          </span>
        }>
          <Menu.Item key="national">National Level</Menu.Item>
          <Menu.Item key="state">State Level</Menu.Item>
          <Menu.Item key="county">County Level</Menu.Item>
          <Menu.Item key="info">Information</Menu.Item>
        </Menu.SubMenu>
        }

        {this.props.mobile &&
        <Menu.Divider/>
        }

        <Menu.SubMenu key="x" title={
          <span>
            <svg width={21} height={12} style={{marginBottom: -2}}>
              <rect width={12} height={12} x={0} y={0} rx={6} ry={6} fill="#e04040"></rect>
            </svg>
            <span className="title">Red Dimension</span>
            <br/>{this.props.xLabel}
          </span>
        }>{fieldsX}</Menu.SubMenu>

        <Menu.Divider/>

        <Menu.SubMenu key="y" title={
          <span>
            <svg width={21} height={12} style={{marginBottom: -2}}>
              <rect width={12} height={12} x={0} y={0} rx={6} ry={6} fill="#0f8ee9"></rect>
            </svg>
            <span className="title">Blue Dimension</span>
            <br/>{this.props.yLabel}
          </span>
        }>{fieldsY}</Menu.SubMenu>

        <Menu.Divider/>

        <Menu.SubMenu key="state" className="scroller" title={
          <span
            onMouseEnter={() => {
              d3.selectAll("#FIPS_" + this.props.selectedState.fips).attr("class", "hover_over");
            }}
            onMouseLeave={() => {
              d3.selectAll("#FIPS_" + this.props.selectedState.fips).attr("class", "hover_out");
            }}>
            <Icon type="compass"/>
            <span className="title">Select State</span>
            <br/>{this.props.selectedState.name}
          </span>
        }>{this.props.states}</Menu.SubMenu>

        <Menu.Divider/>

        <Menu.SubMenu key="county" className="scroller" title={
          <span
            onMouseEnter={() => {
              d3.selectAll("#FIPS_" + this.props.selectedCounty.fips).attr("class", "hover_over");
            }}
            onMouseLeave={() => {
              d3.selectAll("#FIPS_" + this.props.selectedCounty.fips).attr("class", "hover_out");
            }}>
            <Icon type="environment-o"/>
            <span className="title">{'Select ' + this.props.selectedState.abbr + ' County'}</span>
            <br/>{this.props.selectedCounty.name}
          </span>
        }>{this.props.counties}</Menu.SubMenu>

        <Menu.Divider/>

        <Menu.SubMenu key="year" title={
          <span>
            <Icon type="calendar"/>
            <span className="title">Select Year</span>
            <br/>{this.props.year}
          </span>
        }>{this.props.years}</Menu.SubMenu>

        <Menu.Divider/>

        {!this.props.mobile &&
        <Menu.ItemGroup title={<span><Icon type="play-circle-o"/>Year Animation</span>} children={
          <PlayControls year={this.props.year} yearChange={this.props.actions.selectYear}/>
        }/>
        }

        {this.props.mobile &&
        <Menu.ItemGroup key="version" title={
          <div style={{textAlign: 'center', color: '#666'}}>v{version}</div>
        }/>
        }
      </Menu>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    title: props.title,
    page: store.dimensions.page,
    fields: store.dimensions.fields,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    selectedState: store.states.selected,
    selectedCounty: store.counties.selected,
    states: _.map(store.states.list, s => {
      return (<Menu.Item key={s.fips}><a>{s.name}</a></Menu.Item>)
    }),
    counties: _.map(store.counties.list, c => {
      return (<Menu.Item key={c.fips}><a>{c.name}</a></Menu.Item>)
    }),
    years: _.map(store.dimensions.years, y => {
      return (<Menu.Item key={y}><a>{y}</a></Menu.Item>)
    }),
    year: store.dimensions.year
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(SideMenu);



// WEBPACK FOOTER //
// ./src/components/SideMenu/index.js